<template>
	<main class="view-public-notice">
		<div class="pb-detail">
			<comp-public-notice-viewer :notice="publicNotice" v-if="publicNotice" />
		</div>
	</main>
</template>

<script>
import CompPublicNoticeViewer from '../CompPublicNoticeViewer'

export default {
	data() {
		return {
			publicNotice: null
		}
	},
	async created() {
		// 读
		let msg = await this.$api.user.getMessage(this.$route.params.id)
		this.publicNotice = msg.payload

		this.$emit('breadcrumbChange', [
			{
				name: '详情',
				to: null
			}
		])
	},
	components: {
		CompPublicNoticeViewer
	}
}
</script>

<style>
.pb-detail {
	padding: 10px;
}
</style>
